import type { BriefCandidate } from '../hooks/use-briefs'

export type BriefBoardColumn = 'identified' | 'shortlisted' | 'interview' | 'hired' | 'not_progressed'

export const BRIEF_BOARD_COLUMNS: { id: BriefBoardColumn; label: string; decided?: boolean }[] = [
  { id: 'identified', label: 'Identified' },
  { id: 'shortlisted', label: 'Shortlisted' },
  { id: 'interview', label: 'Interview' },
  { id: 'hired', label: 'Hired', decided: true },
  { id: 'not_progressed', label: 'Not progressed', decided: true },
]

/** Fallback for payloads without board_column (mirrors briefs/board.py). */
export function briefCandidateBoardColumn(candidate: BriefCandidate): BriefBoardColumn {
  if (candidate.board_column) return candidate.board_column
  const state = candidate.outcome?.state
  if (state === 'hired') return 'hired'
  if (state === 'failed' || state === 'not_progressed') return 'not_progressed'
  if (candidate.in_interview || state === 'scheduled' || state === 'passed') return 'interview'
  return candidate.stage === 'shortlisted' ? 'shortlisted' : 'identified'
}

/** Moves the server rejects: back out of interview into the pre-interview columns. */
export function canMoveBriefCandidate(from: BriefBoardColumn, to: BriefBoardColumn): boolean {
  if (from === to) return false
  const preInterview = (c: BriefBoardColumn) => c === 'identified' || c === 'shortlisted'
  return !(preInterview(to) && !preInterview(from))
}
